import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nested-loader',
  templateUrl: './nested-loader.component.html',
  styleUrls: ['./nested-loader.component.scss'],
})
export class NestedLoaderComponent {}
